<template>
  <v-card outlined class="allocation-card">
    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        :items="paymentDetail"
        :loading="loading"
        :sort-by="sortBy"
        :page.sync="page"
        :items-per-page="itemsPerPage"
      >
        <template v-slot:item="{ item }">
          <tr class="allocation-row">
            <td @click="viewInvoice(item)" class="text-left pointer">
              <div class="allocation-primary">{{ item.Invoice.date | moment("MMM D, YYYY") }}</div>
              <div class="allocation-secondary">{{ item.Invoice.date | moment("h:mm A") }}</div>
            </td>
            <td @click="viewInvoice(item)" class="text-left pointer">
              <span class="allocation-primary">#{{ item.Invoice.localId }}</span>
              <v-chip v-if="item.stripeChargeId" color="green lighten-5" text-color="green darken-2" x-small label class="ml-2">Online</v-chip>
              <PaymentProviderChip v-if="providerFor(item)" :provider="providerFor(item)" class="ml-2" />
              <v-chip v-if="item.status" color="blue-grey lighten-5" text-color="blue-grey darken-2" x-small label class="ml-2">{{ item.RefundPayment | currency}} <span class="ml-1 text-capitalize">{{ item.status }}</span></v-chip>
              <v-chip v-if="item.donation" color="green lighten-5" text-color="green darken-2" x-small label class="ml-2">Donation</v-chip>
            </td>

            <td class="text-left">
              <span v-if="item.AdvancePayment">{{ item.AdvancePayment.localId }}</span>
            </td>

            <td class="text-left">
              <span v-if="item.Invoice.Customer">{{ item.Invoice.Customer.name }}</span>
              <span v-if="item.Invoice.Donor">{{ item.Invoice.Donor.name }}</span>
              
            </td>

            <td @click="viewInvoice(item)" class="text-left pointer">
              <span class="allocation-amount">{{ item.amount | currency }}</span>
              <div v-if="item.referenceNumber" class="allocation-secondary">Ref: {{ item.referenceNumber }}</div>
            </td>

            <td class="justify-end align-center text-right">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon aria-label="Payment allocation actions">
                    <v-icon>mdi-dots-horizontal</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu-button">
                  <v-list-item @click="viewInvoice(item)">
                    <v-list-item-title>View invoice</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="!item.stripeChargeId"
                    @click="deletePayment(item)">
                    <v-list-item-title>Delete Payment</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          <div class="py-8 text-center text--secondary">No invoice allocations found for this payment.</div>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import paymentService from "../service";
import PaymentProviderChip from "@/components/PaymentProviderChip.vue";
import { mapGetters } from "vuex";
import Hashids from "hashids";
const hashids = new Hashids();
export default {
  props: {
    CustomerId: {
      default: null,
    },
    DonorId: {
      default: null,
    },
    PaymentId: {
      default: null,
    },
    showAll: {
      default: false,
    },
    due: {
      default: false,
    },
  },
  name: "payment-detail-list",
  data() {
    return {
      count: 0,
      loading: true,
      headers: [
      {
          text: "Invoice Date",
          align: "left",
          value: "date",
          sortable: true,
        },
        {
          text: "Invoice Number",
          align: "left",
          value: "localId",
          sortable: true,
        },
        {
          text: "Advance Payment Number",
          align: "left",
          value: "AdvancePayment.localId",
          sortable: true,
        },
        {
          text: "Name",
          align: "left",
          value: "Invoice.Customer.name",
          sortable: true,
        },
        {
          text: "Amount",
          align: "left",
          value: "amount",
          sortable: true,
        },

        {
          text: "",
          value: "action",
          sortable: false,
          width: "20px",
        },
      ],
      paymentDetail: [],
      search: null,
      page: 1,
      sortBy: "Invoice.localId",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  components: {
    PaymentProviderChip,
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  created() {
    this.getList();
  },
  methods: {
    providerFor(item) {
      if (item.paymentProvider) return item.paymentProvider;
      if (item.MerchantAccount && item.MerchantAccount.provider) return item.MerchantAccount.provider;
      if (item.Invoice && item.Invoice.paymentProvider) return item.Invoice.paymentProvider;
      return item.stripeChargeId && String(item.stripeChargeId).indexOf("ch_") === 0 ? "STRIPE" : item.stripeChargeId ? "PAYCOMPASS" : null;
    },
    viewInvoice(invoice) {
      const hashId = hashids.encode(invoice.InvoiceId);

      const routeData = this.$router.resolve({
        path: `/global/invoice/${hashId}/view`,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    getList() {
      // console.log('payment', this.PaymentId)
      return paymentService
        .getDetailById(this.PaymentId, { CustomerId: this.CustomerId, DonorId: this.DonorId })
        .then((response) => {
          this.paymentDetail = response.data;
          this.loading = false;
          return response;
        });
    },
    deletePayment(payment) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          paymentService.deletePaymentDetail(payment.id).then((response) => {
            if (response.data) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Payee has been deleted.",
                });
              // this.$swal("Deleted!", "Payee has been deleted.", "success");
              this.getList();
              this.$events.emit("paymentListEvent");
              this.$events.emit("customerProfileEvent");
              this.$events.emit("invoiceListEvent");
              this.$events.emit("advancePaymentListEvent");
              this.$events.emit("advancePaymentDetailListEvent");
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.allocation-card {
  border-color: #dfe7df !important;
  border-radius: 10px !important;
  overflow: hidden;
}

.allocation-row:hover {
  background: #f8faf8;
}

.allocation-primary,
.allocation-amount {
  color: #172033;
  font-weight: 700;
}

.allocation-secondary {
  color: #8c978f;
  font-size: 0.74rem;
}
</style>
